import { render, staticRenderFns } from "./PasswordChange.vue?vue&type=template&id=ab893ede&scoped=true"
import script from "./PasswordChange.vue?vue&type=script&lang=ts"
export * from "./PasswordChange.vue?vue&type=script&lang=ts"
import style0 from "./PasswordChange.vue?vue&type=style&index=0&id=ab893ede&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab893ede",
  null
  
)

export default component.exports